import { IDog, IProfile } from '@jumpstart/core';
import RefreshIcon from '@mui/icons-material/Refresh';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';
import React, { useEffect, useRef, useState } from 'react';
import ChatBubble from '../../../widgets/ChatBubble';
import { IDailyMessage, IMessageInstance, ISubscriber } from '../schemas';
import MessageBar from './MessageBar';
import { getConversation } from './services/Texting';

const POCKET_SCOUT = `${process.env.PUBLIC_URL}/assets/images/logos/scout9-logo-blue-diamond.png`;
const PROFILE_PLACEHOLDER = `${process.env.PUBLIC_URL}/assets/images/placeholder2.png`;


export interface IChatView {
  subscriber: ISubscriber;
  profile: IProfile;
  dog: IDog;
  messages: IDailyMessage[];
}

function LoadingChatView() {
  return (
    <Grid
      container
      direction="column"
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: (theme) => theme.palette.background.paper
      }}
      wrap="nowrap"
      justifyContent="space-between"
      alignItems="stretch"
    >
    <Grid container direction="column" style={{ padding: 24 }} wrap="nowrap">
      <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row-reverse" wrap="nowrap">
        <Skeleton variant="rectangular" width="100%" height={80} style={{margin: 6, borderRadius: 5}}/>
        <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
      </Grid>
      <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row" wrap="nowrap">
        <Skeleton variant="rectangular" width="100%" height={100} style={{margin: 6, borderRadius: 5}}/>
        <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
      </Grid>
      <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row-reverse" wrap="nowrap">
        <Skeleton variant="rectangular" width="100%" height={95} style={{margin: 6, borderRadius: 5}}/>
        <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
      </Grid>
      <Grid item container justifyContent="flex-end" style={{width: '100%'}} direction="row" wrap="nowrap">
        <Skeleton variant="rectangular" width="100%" height={120} style={{margin: 6, borderRadius: 5}}/>
        <Skeleton variant="circular" width={40} height={40} style={{margin: 6, minWidth: 40, minHeight: 40}}/>
      </Grid>
    </Grid>
    </Grid>
  );
}


export default function ChatView(props: IChatView) {
  const { subscriber, profile, dog, messages } = props;
  // const [messages, setMessages] = useState<IDailyMessage[]>([]);
  // const [lastKey, setLastKey] = useState<number | string>('');
  // const [nextMessagesLoading, setNextMessagesLoading] = useState(false);
  const messageRefs = useRef<HTMLDivElement>(null);
  const [textMessages, setTextMessages] = useState<IMessageInstance[]>([]);
  const [pulling, setPulling] = useState(false);

  const handlePull = () => {
    if (pulling) {
      return;
    }
    setPulling(true);
    getConversation(subscriber.phone)
      .then((messages: IMessageInstance[]) => {
        setPulling(false);
        setTextMessages(messages);
        if (messageRefs.current) {
          // Scroll to bottom
          messageRefs.current.scrollTop = 100000;
        }
      })
      .catch((err: Error) => {
        console.error(err);
        setPulling(false);
      });
  };


  // useEffect(() => {
  //   if (messageRefs.current) {
  //     // Scroll to bottom
  //     messageRefs.current.scrollTop = 100000;
  //   }
  //   handlePull();
  // }, [messages]);

  useEffect(() => {
    handlePull();
  }, [subscriber]);

  const body = (instance: IMessageInstance) => {
    let b = '';
    if (instance.errorCode) {
      b += `(${instance.errorCode} ${instance.errorMessage ? instance.errorMessage : 'Error Code'}) `;
    }
    b += instance.body;
    return b;
  };


  // For pagination
  const sortData = (a: IDailyMessage, b: IDailyMessage) => a.day - b.day;
  // useEffect(() => {
  //   setMessages([]);
  //   setLastKey('');
  //   if (!subscriber) {
  //     return;
  //   }
  //   // Reset messages
  //   setNextMessagesLoading(true);
  //   console.log(`scout9-messages/${subscriber.phone}/messages`);
  //   Post.postsFirstBatch<IDailyMessage>(db.collection(`scout9-messages/${subscriber.phone}/messages`), 'day', 15, 'desc')
  //     .then(({ data, lastKey }) => {
  //       setMessages(data.sort(sortData));
  //       console.log('LAST KEY!!', lastKey)
  //       setLastKey(lastKey);
  //       setNextMessagesLoading(false);
  //       if (messageRefs.current) {
  //         // Scroll to bottom
  //         messageRefs.current.scrollTop = 100000;
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       setNextMessagesLoading(false);
  //     });
  // }, [subscriber]);

  // const fetchMore = (key: number) => {
  //   if (typeof key === 'number' && key > 0 && subscriber) {
  //     setNextMessagesLoading(true);
  //     Post.postsNextBatch<IDailyMessage>(
  //       key,
  //       db.collection(`scout9-messages/${subscriber.phone}/messages`),
  //       'day',
  //       15,
  //       'desc'
  //     )
  //       .then(({ data, lastKey }) => {
  //         console.log(data, lastKey);
  //         setLastKey(lastKey);
  //         // add new posts to old posts
  //         setMessages(messages.concat(data).sort(sortData));
  //         setNextMessagesLoading(false);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         setNextMessagesLoading(false);
  //       });
  //   }
  // };
  //
  //

  if (pulling) {
    return (<LoadingChatView/>);
  }

  return (
    <Grid
      container
      direction="column"
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: (theme) => theme.palette.background.paper
      }}
      wrap="nowrap"
      justifyContent="space-between"
      alignItems="stretch"
    >
      <div style={{position: 'relative', zIndex: 1}}>
        <Grid item container justifyContent="center" alignItems="center" style={{position: 'absolute', top: 12}}>
          <IconButton size="small" style={{backgroundColor: '#FAFAFA'}} onClick={handlePull}><RefreshIcon/></IconButton>
        </Grid>
      </div>
      <Grid
        container
            direction="column"
        sx={{
          padding: 6,
          overflowY: 'scroll',
        }}
        wrap="nowrap"
        ref={messageRefs}
      >

        {/*Paginate messages*/}

        {/*{!!subscriber ? (nextMessagesLoading ? (*/}
        {/*    <CircularProgress size={32}/>*/}
        {/*  ) : typeof lastKey === 'number' && lastKey > 0 ? (*/}
        {/*    <Button onClick={() => fetchMore(lastKey)}>More</Button>*/}
        {/*  ) : (*/}
        {/*    <Typography variant="caption" style={{ textAlign: 'center' }}>End of messages</Typography>*/}
        {/*  )) :*/}
        {/*  <Typography variant="caption" style={{ textAlign: 'center', padding: 24 }}>Select a subscriber</Typography>}*/}

        {/*Messages (Chat Bubbles)*/}
        {/*{*/}
        {/*  !!messages ? (messages*/}
        {/*      .filter((message: IDailyMessage) => !!(message.replies && message.replies.length > 0) || !!message.dialog.body)*/}
        {/*      .sort(sortData)*/}
        {/*      .map((message: IDailyMessage) => <MessageView message={message} profile={profile} dog={dog}*/}
        {/*                                                    subscriber={subscriber}*/}
        {/*                                                    key={message.id}*/}
        {/*      />))*/}
        {/*    : null*/}
        {/*}*/}
        {
          textMessages.map((instance: IMessageInstance) => <ChatBubble
              key={instance.sid}
              body={body(instance)}
              direction={instance.pocketScout ? 'right' : 'left'}
              avatar={{src: instance.pocketScout ? POCKET_SCOUT : PROFILE_PLACEHOLDER}}
              date={instance.dateSent}
              // style={{opacity: !!instance.errorCode ? 0.7 : 1}}
            />
          )
        }
      </Grid>


      {/*Message Bar*/}
      {!!subscriber && !!profile && !!dog ? <MessageBar subscriber={subscriber} profile={profile} dog={dog}/> : null}

    </Grid>
  );
}
